import { v4 as uuidv4 } from 'uuid';

export const createSortKeyByUUID = () => {
  return uuidv4() as string;
};
